import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'src/app/services/toast.service';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoginPageComponent {
  public loginForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
  });

  private subscription = new Subscription();
  private redirectUrl: string = '/dashboard';
  private activatedRouteSub: Subscription;

  constructor(
    private authService: AuthService,

    private toastService: ToastService,
  ) {}

  // logges in employee if login data is valid.
  public loginUser(): void {
    if (this.loginForm.invalid) {
      return;
    }
    this.subscription.add(
      this.authService.login(this.loginForm.get('email').value, this.loginForm.get('password').value).subscribe({
        next: (res) => {
          this.toastService.success('You are logged in :)');
        },
        error: (err: any) => {
          if (err.error['DATA'] == 'Invalid credentials!' || err.error['DATA'] === 'No such email')
            this.toastService.error('Invalid username or password. Please try again');
        },
      }),
    );
  }

  public get email() {
    return this.loginForm.get('email');
  }

  public get password() {
    return this.loginForm.get('password');
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
